<template>
  <div :class="custom">
    <div v-if="metadato">
      <label class="text-sm font-semibold text-secondary-600 block mb-1">
        <base-obligatory-icon v-if="required.campo" />
        {{ longText ? $t('invoices.metadatos.metadato_campo') : $t('invoices.metadatos.metadato_campo_short') }}
      </label>
      <el-form-item :prop="campoProp">
        <base-el-select ref="camposelect" :options="finalListMetadatasClient" v-model="metadato.campo"
          class="w-full" clearable filterable :allow-create="allowCreate" :default-first-option="allowCreate" :maxlength="250"
          :loading="loadingMetadatos" :queryReplacer="queryReplacer" />
      </el-form-item>
    </div>
    <div v-if="metadato">
      <div class="flex justify-between items-center mb-1">
        <label class="text-sm font-semibold text-secondary-600 block mb-1">
          <base-obligatory-icon v-if="required.valor" />
          {{ longText ? $t('invoices.metadatos.metadato_valor') : $t('invoices.metadatos.metadato_valor_short') }}
        </label>
        <base-select v-if="showOperator" v-model="metadato.operador" :data="operators" size="tinyxs"
          :disabled="disabled.operador" />
      </div>

      <el-form-item v-if="!showOperator || ![4, 5].includes(metadato.operador)" :prop="valorProp">
        <el-input clearable class="w-full" v-model="metadato.valor" maxlength="250" :disabled="disabled.valor" />
      </el-form-item>
    </div>
  </div>
</template>

<script>
import { i18n } from '@/i18n'
import { getListMetadatas } from '@/services/clients/lists/getListMetadatas'

import Metadato from '@/classes/metadata/Metadato'

export default {
  name: 'base-metadato-form-item',
  props: {
    custom: {
      type: String,
      default: '',
    },
    idCliente: {
      type: Number,
      default: null,
    },
    clientMetadatasList: {
      type: Array,
      default: null,
    },
    metadato: {
      type: Metadato,
      required: true,
    },
    required: {
      type: Object,
      default: () => ({ campo: false, valor: false }),
    },
    disabled: {
      type: Object,
      default: () => ({ campo: false, valor: false, operador: false }),
    },
    campoProp: {
      type: String,
      default: 'campo',
    },
    valorProp: {
      type: String,
      default: 'valor',
    },
    allowCreate: {
      type: Boolean,
      default: false,
    },
    showOperator: {
      type: Boolean,
      default: false,
    },
    longText: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      loadingMetadatos: false,
      finalListMetadatasClient: [],
    }
  },
  computed: {
    operators: function () {
      return this.$store.getters['config/OPERADORES']
    }
  },
  mounted: function () {
    this.reloadMetadataList()
  },
  methods: {
    reloadMetadataList: async function () {
      this.loadingMetadatos = true
      if (this.clientMetadatasList) {
        this.finalListMetadatasClient = this.clientMetadatasList
      } else {
        this.finalListMetadatasClient = []
        const respuestaMetadataClient = await getListMetadatas({ idCliente: this.idCliente })
        if (respuestaMetadataClient.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', respuestaMetadataClient))
        } else {
          this.finalListMetadatasClient = respuestaMetadataClient.Respuesta
        }
      }
      this.loadingMetadatos = false
    },
    queryReplacer: function (query) {
      return query.toLocaleUpperCase().replaceAll(' ', '_')
    }
  },
  watch: {
    idCliente: function (value, oldValue) {
      if (value !== oldValue) {
        this.reloadMetadataList()
      }
    },
    finalListMetadatasClient (value, oldValue) {
      if (!value.some(x => x === this.metadato.campo)) {
        this.metadato.campo = ''
        this.metadato.operador = this.metadato.operador ? 1 : null
        this.metadato.valor = ''
      }
      // this.listMetadatasClient = value
    },
    'metadato.campo': function (value, oldValue) {
      if (value !== oldValue) {
        this.$emit('change', { campo: value, valor: this.metadato.valor, operador: this.metadato.operador }, { campo: oldValue, valor: this.metadato.valor, operador: this.metadato.operador })
      }
    },
    'metadato.valor': function (value, oldValue) {
      if (value !== oldValue) {
        this.$emit('change', { campo: this.metadato.campo, valor: value, operador: this.metadato.operador }, { campo: this.metadato.campo, valor: oldValue, operador: this.metadato.operador })
      }
    },
    'metadato.operador': function (value, oldValue) {
      if (value !== oldValue) {
        this.$emit('change', { campo: this.metadato.campo, valor: this.metadato.valor, operador: value }, { campo: this.metadato.campo, valor: this.metadato.valor, operador: oldValue })
      }
    },
  }
}
</script>

<style scoped></style>
